import { EventEmitter } from 'eventemitter3';

const eventEmitter = new EventEmitter()

const Emitter = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  on: (event: string, fn: (...args: any[]) => void) => eventEmitter.on(event, fn),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  once: (event: string, fn: (...args: any[]) => void) => eventEmitter.once(event, fn),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  off: (event: string, fn: (...args: any[]) => void) => eventEmitter.off(event, fn),
  emit: (event: string, payload: unknown) => eventEmitter.emit(event, payload),
}

Object.freeze(Emitter)

const emitEvent = (name: string, data?: object | string | number | null) => {

  // console.log(`EventEmitter: ${name}`, data)
  return new Promise<void>((resolve) => {
    Emitter.emit(name as string, data)

    resolve()
  })
}

export { Emitter, emitEvent }
